import * as React from 'react';
import * as styles from './TourPlaceholder.css';
import { ArticleHeading4, ArticleParagraph1, Button, Responsive } from '@cian/ui-kit';

import { IconProduct3DPlan24 } from '@cian/ui-kit-design-tokens/icons';

interface ITourPlaceholderProps {
  src?: string;
  onClick?(): void;
}

export const TourPlaceholder: React.FC<ITourPlaceholderProps> = ({ src, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      {src && <img className={styles['img']} src={src} />}
      <div className={styles['content']}>
        <Responsive desktop>
          <div className={styles['icon-desktop']} />
          <div className={styles['text-desktop']}>
            <ArticleParagraph1 color="text-on-bright-default">
              Погуляйте по дому,
              <br />
              чтобы оценить планировку
            </ArticleParagraph1>
          </div>
          <Button theme="fill_white_primary" size="XS">
            Погулять по дому
          </Button>
        </Responsive>
        <Responsive tablet phone>
          <div className={styles['icon']}>
            <IconProduct3DPlan24 color="icon-on-bright-default" />
          </div>
          <ArticleHeading4 color="text-on-bright-default">Посмотреть в 3D</ArticleHeading4>
        </Responsive>
      </div>
    </div>
  );
};
